<mat-stepper>
  <mat-step completed="false" label="Search" state="search">
    <div class="step-content">
      <div>Use Search tabs to find Obligors by name or their related issues by CUSIP6, CUSIP8 or CUSIP9</div>
      <div class="image-row">
        <img src="assets/img/search_obligor.png" alt="Search Obligor Form">
        <img src="assets/img/search_cusip.png" alt="Search CUSIP Form">
      </div>
    </div>
    <button mat-stroked-button (click)="closeStepper()">Close</button>
    <div class="buttons-right">
      <button mat-stroked-button color="primary" matStepperNext>Next</button>
    </div>
  </mat-step>

  <mat-step completed="false" label="Search Results" state="manage_search">
    <div class="step-content">
      <div>Review Search Results and Financial Reports availability</div>
      <div class="image-row">
        <img src="assets/img/search_results.png" alt="Search Results">
      </div>
    </div>
    <button mat-stroked-button (click)="closeStepper()">Close</button>
    <div class="buttons-right">
      <button mat-stroked-button matStepperPrevious>Back</button>
      <button mat-stroked-button color="primary" matStepperNext>Next</button>
    </div>
  </mat-step>

  <mat-step completed="false" label="Report Preview" state="request_quote">
    <div class="step-content">
      <div>Chose a search result to view / export available Financial data and MuniPOINTS information as a PDF or CSV
        file. (Access to MuniPOINTS and export functionality may be restricted for some users.)
      </div>
      <div class="image-row">
        <img src="assets/img/preview.png" alt="Preview Report">
      </div>
    </div>
    <button mat-stroked-button (click)="closeStepper()">Close</button>
    <div class="buttons-right">
      <button mat-stroked-button matStepperPrevious>Back</button>
      <button mat-stroked-button color="primary" matStepperNext>Next</button>
    </div>
  </mat-step>

  <mat-step completed="false" label="User Notes" state="edit_note">
    <div class="step-content">
      <div>Record your notes on a specific Obligor</div>
      <div class="image-row">
        <img src="assets/img/notes.png" style="max-width: 100%" alt="User Notes">
      </div>
    </div>
    <button mat-stroked-button (click)="closeStepper()">Close</button>
    <div class="buttons-right">
      <button mat-stroked-button matStepperPrevious>Back</button>
      <button mat-stroked-button color="primary" matStepperNext>Next</button>
    </div>
  </mat-step>

  <mat-step completed="false" label="Recent Actions" state="youtube_searched_for">
    <div class="step-content">
      <div>Access recently viewed Obligors or Searches performed by your or other users within your company</div>
      <div class="image-row">
        <img src="assets/img/recently_viewed.png" alt="Recently Viewed">
        <img src="assets/img/recent_search.png" alt="Recent Searches">
      </div>
    </div>
    <button mat-stroked-button (click)="closeStepper()">Close</button>
    <div class="buttons-right">
      <button mat-stroked-button matStepperPrevious>Back</button>
      <button mat-stroked-button color="primary" (click)="closeStepper()">Got it!</button>
    </div>
  </mat-step>

  <ng-template matStepperIcon="edit">
    <mat-icon>radio_button_unchecked</mat-icon>
  </ng-template>
</mat-stepper>
